<script setup lang="ts">
import { toRefs } from 'vue';

const props = defineProps<{
  slideIndex: number;
  totalSlides: number;
  classes: string;
}>();
const { slideIndex, totalSlides, classes } = toRefs(props);
</script>
<template>
  <span :class="classes">
    {{
      slideIndex < 1 ? totalSlides : slideIndex <= totalSlides ? slideIndex : 1
    }}
    of {{ totalSlides }}
  </span>
</template>

<style scoped></style>
